export { default } from '@polleverywhere/fetch/lib/token_store';